import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { ApiService } from '../../../../core/services/api/api.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { LabelService } from '@app/services/label/label.service';
import { UserService } from '@app/services/user/user.service';

@Component({
  selector: 'app-viewprintingjobs',
  templateUrl: './viewprintingjobs.component.html',
  styleUrls: ['./viewprintingjobs.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ViewprintingjobsComponent implements OnInit {
  public get sanitizer(): DomSanitizer {
    return this._sanitizer;
  }

  public set sanitizer(value: DomSanitizer) {
    this._sanitizer = value;
  }

  id: any;
  html: any;
  url = '';
  urlSafe: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public apiService: ApiService,
    private userService: UserService,
    private labelService: LabelService,
    private _sanitizer: DomSanitizer,
  ) {
    this.id = data.id;
  }

  async ngOnInit(): Promise<void> {
    const url = `${this.apiService.API_URL}label/labels/orders/${this.id}?noPrint=true`;

    const { token }: any = await this.userService.getSecurityToken(url);

    this.url = `${url}&token=${token}`;

    this.html = this.labelService.getLabels(this.id, token);

    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }
}
